module.exports = __webpack_public_path__ + "img/cloud-arrow-up-solid.bb94f753.svg";